import type { WizardParkingChoice } from "./PermitContextProvider/types";

export const splitChoicesByAvailability = (choices: WizardParkingChoice[]) => {
	const available: WizardParkingChoice[] = [];
	const upcoming: WizardParkingChoice[] = [];

	for (const choice of choices) {
		const isAvailable =
			(!choice.rangeStart || new Date(choice.rangeStart) <= new Date()) &&
			(!choice.rangeEnd || new Date(choice.rangeEnd) > new Date());

		if (isAvailable) {
			available.push(choice);
		}

		if (choice.rangeStart && new Date(choice.rangeStart) > new Date()) {
			upcoming.push(choice);
		}
	}

	available.sort((a, b) => a.priority - b.priority);
	upcoming.sort((a, b) => a.priority - b.priority);

	return { availableChoices: available, upcomingChoices: upcoming };
};
